/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import withBillingDetails from '@modules/billing-lib/billingDetails/withBillingDetails'

import { getCommonProfile } from '@/reducers/profile'
import { fetchAccountActivity, updateBillingLevel } from '@/apps/userconsole/actions/account'
import {
  fetchUsageDetailsRequest,
  getUsageDetails,
  fetchUpdateBillingLevelRequest,
} from '@/apps/userconsole/reducers/account'

import { fetchUsageDetails } from '../../../apps/userconsole/actions/billing/details'

import SelectSubscriptionModal from './SelectSubscriptionModal'

import type { StateProps, DispatchProps, ConsumerProps } from './types'
import type { ThunkDispatch } from '@/types/redux'

const mapStateToProps = (state): StateProps => ({
  profile: getCommonProfile(state),
  updateBillingLevelRequest: fetchUpdateBillingLevelRequest(state),
  usageDetails: getUsageDetails(state)!,
  fetchUsageDetailsRequest: fetchUsageDetailsRequest(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  updateBillingLevel: (args) => dispatch(updateBillingLevel(args)),
  fetchUsageDetails: (args) => dispatch(fetchUsageDetails(args)),
  fetchAccountActivity: (organizationId) => dispatch(fetchAccountActivity(organizationId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(withBillingDetails(SelectSubscriptionModal))
